const UserList = () => import(
    /* webpackChunkName: "EnterpriseList" */
    './EnterpriseUserList');
const RoleList = () => import(
    /* webpackChunkName: "SystemAdminList" */
    './EnterpriseRoleList');
const IconSettings = () => import(
    /* webpackChunkName: "SystemSetting" */
    './IconSettings');
const BusinessOrg = () => import(
        /* webpackChunkName: "SystemSetting" */
    './BusinessOrg');
const SelectOrg = () => import(
            /* webpackChunkName: "SystemSetting" */
    './selectOrg');
const UserPreference = () => import(
/* webpackChunkName: "UserPreference" */
'./UserPreference');
export default {
  pages: [
    {
      name: 'enterprise-user-list',
      path: 'enterprise-user-list',
      component: UserList,
    },
    {
      name: 'enterprise-role-list',
      path: 'enterprise-role-list',
      component: RoleList,
    },
    {
      name: 'enterprise-setting',
      path: 'enterprise-setting',
      component: IconSettings,
    },
    {
      name: 'organization-list',
      path: 'organization-list',
      component: BusinessOrg,
    },
    {
      name: 'select-org',
      path: 'select-org',
      component: SelectOrg,
    },
    {
      name: 'user-preference',
      path: 'user-preference',
      component: UserPreference,
    },
  ],
};




// WEBPACK FOOTER //
// ./src/manage-modules/UserManage/index.js